export interface NavMenuProps {
  children: JSX.IntrinsicElements['menu']['children'];
}

const NavMenu = ({ children }: NavMenuProps) => {
  return <menu className="pt-9 space-y-5">{children}</menu>;
};

export default NavMenu;
